import { RadioButton } from "plos/src/components/forms/RadioButton";
import { RadioButtonGroup } from "plos/src/components/forms/RadioButtonGroup";
import { useTranslation } from "react-i18next";
import { useOnboardingContext } from "../../../../contexts/OnboardingContext";
import {
  autoPickChoiceSubtitle,
  onboarding,
  onboardingTitle,
} from "../onboarding.css";
import { AutoPickChoice as AutoPickChoiceValue } from "../types";
import { getTutorialChoices } from "../utils";

const AutoPickChoice = () => {
  const { autopickChoice, setAutopickChoice } = useOnboardingContext();
  const { t } = useTranslation("onboarding");
  const tutorialChoices = getTutorialChoices(t);

  const title = t(
    "autoPickChoiceTitle",
    "Would you like help building your team?",
  );

  return (
    <div className={onboarding}>
      <h1 className={onboardingTitle} id="sheet-title">
        {title}
      </h1>
      <p className={autoPickChoiceSubtitle}>
        {t(
          "autoPickChoiceSubtitle",
          "Next, let's set up your squad. Don't worry — you can make unlimited changes before your season starts.",
        )}
      </p>
      <RadioButtonGroup
        label={title}
        value={autopickChoice}
        onChange={(value) => setAutopickChoice(value as AutoPickChoiceValue)}
        hideLabel
        aria-label={title}
      >
        {tutorialChoices.map(({ value, label, extendedLabel }) => (
          <RadioButton
            key={value}
            value={value}
            autoFocus={value === "manual_pick"}
            fontWeight="regular"
            description={extendedLabel}
          >
            {label}
          </RadioButton>
        ))}
      </RadioButtonGroup>
    </div>
  );
};

export default AutoPickChoice;
